import { css } from 'styled-components';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontNormal } from 'style/styled-components/cssGlobalVariables';

export const RadioButtonGroup = styled.label<{ isHorizontal?: boolean }>`
    background-color: ${(props) => (props.isHorizontal ? '' : props.theme.brandedConfig.low_contrast)};
    border-radius: 4px;
    margin-bottom: 8px;
    padding: 18px 16px;
    position: relative;
    cursor: pointer;

    position: relative;
    display: flex;
    align-items: center;

    line-height: 24px;
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 16px;
    font-family: ${fontNormal};

    [type='radio']:checked,
    [type='radio']:not(:checked) {
        position: absolute;
        left: -9999px;
    }

    [type='radio']:checked ~ .check-mark-icon,
    [type='radio']:not(:checked) ~ .check-mark-icon {
        position: absolute;
        display: block;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;

        svg {
            display: block;
            width: 20px;
            height: 20px;

            path {
                fill: ${(props) => props.theme.brandedConfig.high_contrast};
            }
        }
    }
    [type='radio']:not(:checked) ~ .check-mark-icon {
        opacity: 0;
    }
    [type='radio']:checked ~ .check-mark-icon {
        opacity: 1;
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }

    ${(props) =>
        props.isHorizontal
            ? css`
                  padding: 8px;

                  &:has(> [type='radio']:checked) {
                      padding-left: 32px;
                  }

                  [type='radio']:checked ~ .check-mark-icon {
                      background: var(--color-dark-body-20);
                      border-radius: 4px;
                      padding: 8px;
                      line-height: 24px;

                      transform: none;
                      top: 0;
                      left: 0;
                      right: 0;
                      bottom: 0;

                      svg {
                          position: relative;
                          left: -1px;
                          top: 3px;
                      }
                  }
              `
            : css``}
`;
